import { render, staticRenderFns } from "./FriendGet.vue?vue&type=template&id=7330f4d8&scoped=true"
import script from "./FriendGet.vue?vue&type=script&lang=js"
export * from "./FriendGet.vue?vue&type=script&lang=js"
import style0 from "./FriendGet.vue?vue&type=style&index=0&id=7330f4d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7330f4d8",
  null
  
)

export default component.exports